<div *ngIf="!isRecyclingBinSelected; else recyclingBinToolbar" class="toolbar-container">
  <div class="toolbar-left">
    <ng-container *ngIf="!isPpwrViewEnabled">
      <button *ngIf="isAddEditAllowed" mat-button class="folder-button" [matMenuTriggerFor]="createMenu" type="button">
        {{ 'dataManagement.directory.toolbar.create.button' | transloco }}
      </button>
      <button *ngIf="isUserAdmin" mat-button class="folder-button" [matMenuTriggerFor]="settingsMenu" type="button">
        {{ 'dataManagement.directory.toolbar.settings.button' | transloco }}
      </button>
      <button
        mat-button
        class="folder-button"
        (click)="comparePackagingPart()"
        *ngIf="selectedPackagingPartTab === packagingPartEnum.System || selectedPackagingPartTab === packagingPartEnum.Unit"
        [disabled]="selectedEntriesCount < 2 || selectedEntriesCount > 10 || !isComparisonAllowed"
        type="button">
        {{ 'dataManagement.directory.toolbar.compare' | transloco }}
      </button>
      <button mat-button class="folder-button" (click)="movePackagingPart()" [disabled]="selectedEntriesCount < 1" type="button">
        {{ 'dataManagement.directory.toolbar.move' | transloco }}
      </button>
      <button mat-button class="folder-button" (click)="copyPackagingPart()" [disabled]="selectedEntriesCount < 1" type="button">
        {{ 'dataManagement.directory.toolbar.copy' | transloco }}
      </button>
      <button mat-button class="folder-button" (click)="deletePackagingPart()" [disabled]="selectedEntriesCount < 1" type="button">
        {{ 'dataManagement.directory.toolbar.delete' | transloco }}
      </button>
      <button mat-button class="folder-button" (click)="exportPackagingPart()" [disabled]="selectedEntriesCount < 1" type="button">
        {{ 'dataManagement.directory.toolbar.export' | transloco }}
      </button>
      <button mat-button class="folder-button" [matMenuTriggerFor]="downloadMenu" [disabled]="selectedEntriesCount < 1" type="button">
        {{ 'dataManagement.directory.toolbar.download' | transloco }}
      </button>
      <button mat-button class="folder-button" (click)="editPackagingPartQuantity()" [disabled]="selectedEntriesCount < 1 || !isEnterQuantitiesAllowed" type="button">
        {{ 'dataManagement.directory.toolbar.enterQuantities' | transloco }}
      </button>
      <button mat-button class="folder-button" (click)="editPackagingPartTags()" [disabled]="selectedEntriesCount !== 1" type="button">
        {{ 'dataManagement.directory.toolbar.selectTags' | transloco }}
      </button>
      <button mat-button class="folder-button" (click)="addPackagingPartTags()" [disabled]="selectedEntriesCount < 1" type="button">
        {{ 'dataManagement.directory.toolbar.addTags' | transloco }}
      </button>
      <button mat-button class="folder-button" (click)="createDataExchangeRequest()" [disabled]="selectedEntriesCount < 1" type="button">
        {{ 'dataManagement.directory.toolbar.createDataExchangeRequest' | transloco }}
      </button>
    </ng-container>

    <ng-container *ngIf="isPpwrViewEnabled">
      <button mat-button class="folder-button" (click)="createTechnicalDocumentation()" [disabled]="!isCreateDocOrTechnicalDocumentationPossible()" type="button">
        {{ 'createDoc.toolbar.createTechnicalDocButton' | transloco }}
      </button>
      <button mat-button class="folder-button" (click)="createDoc()" [disabled]="!isCreateDocOrTechnicalDocumentationPossible()" type="button">
        {{ 'createDoc.toolbar.createDocButton' | transloco }}
      </button>
      <button mat-button class="folder-button" (click)="createDataExchangeRequest()" [disabled]="selectedEntriesCount < 1" type="button">
        {{ 'dataManagement.directory.toolbar.createDataExchangeRequest' | transloco }}
      </button>
      <button mat-button class="folder-button" (click)="setInternalApproval(true)" [disabled]="selectedEntriesCount < 1" type="button">
        {{ 'dataManagement.directory.toolbar.ppwr.setApproval' | transloco }}
      </button>
      <button mat-button class="folder-button" (click)="setInternalApproval(false)" [disabled]="selectedEntriesCount < 1" type="button">
        {{ 'dataManagement.directory.toolbar.ppwr.revokeApproval' | transloco }}
      </button>
    </ng-container>
  </div>

  <span class="view-label">{{ 'dataManagement.directory.toolbar.ppwr.view' | transloco }}:</span>
  <mat-button-toggle-group hideSingleSelectionIndicator class="view-toggle" [value]="isPpwrViewEnabled" (change)="onViewChanged($event.value)">
    <mat-button-toggle class="folder-button view-toggle-button" [value]="false">
      {{ 'dataManagement.title' | transloco }}
    </mat-button-toggle>
    <span></span>
    <span [matTooltip]="!isPPWRAllowed ? ('createDoc.toolbar.ppwrNotAllowedTooltip' | transloco) : ''">
      <mat-button-toggle [disabled]="!isPPWRAllowed" class="folder-button view-toggle-button" [value]="true">
        {{ 'ppwrDocuments.viewChangeButton' | transloco }}
      </mat-button-toggle>
    </span>
  </mat-button-toggle-group>
</div>

<ng-template #recyclingBinToolbar>
  <button mat-button class="folder-button" (click)="deletePackagingPart()" [disabled]="selectedEntriesCount < 1" type="button">
    {{ 'dataManagement.directory.toolbar.delete' | transloco }}
  </button>
  <button mat-button class="folder-button" (click)="restorePackagingPart()" [disabled]="selectedEntriesCount < 1" type="button">
    {{ 'dataManagement.directory.toolbar.restore' | transloco }}
  </button>
</ng-template>

<mat-menu #createMenu="matMenu" [overlapTrigger]="false">
  <button mat-menu-item (click)="addFolder()" type="button">
    <span>{{ 'dataManagement.directory.toolbar.create.folder' | transloco }}</span>
  </button>
  <button mat-menu-item (click)="createPackagingSystem()" type="button">
    <span>{{ 'dataManagement.directory.toolbar.create.packagingSystem' | transloco }}</span>
  </button>
  <button mat-menu-item [matMenuTriggerFor]="packagingUnitMenu" type="button">
    <span>{{ 'dataManagement.directory.toolbar.create.packagingUnit' | transloco }}</span>
  </button>
  <button mat-menu-item [matMenuTriggerFor]="componentMenu" type="button">
    <span>{{ 'dataManagement.directory.toolbar.create.packagingComponent' | transloco }}</span>
  </button>
  <button mat-menu-item (click)="createCompositeMaterial()" type="button">
    <span>{{ 'dataManagement.directory.toolbar.create.compositeMaterial' | transloco }}</span>
  </button>
</mat-menu>

<mat-menu #packagingUnitMenu="matMenu" [overlapTrigger]="false">
  <button mat-menu-item (click)="createPackagingUnit()" type="button">
    {{ 'home.packagingUnitHome.addUnitButton' | transloco }}
  </button>
</mat-menu>

<mat-menu #componentMenu="matMenu" [overlapTrigger]="false">
  <span *ngFor="let componentType of componentCategories; let i = index">
    <button mat-menu-item (click)="createPackagingComponent(componentType.key)" type="button">
      {{ 'common.dictionary.' + componentType.label | transloco }}
    </button>
  </span>
</mat-menu>

<mat-menu #settingsMenu="matMenu" [overlapTrigger]="false">
  <button mat-menu-item (click)="openPermissionsDialog()" type="button">
    <span>{{ 'dataManagement.directory.toolbar.settings.permissions' | transloco }}</span>
  </button>
</mat-menu>

<mat-menu #downloadMenu="matMenu" [overlapTrigger]="false">
  <button mat-menu-item (click)="downloadPackagingPart()" type="button">
    {{ 'dataManagement.directory.toolbar.downloadTypes.json' | transloco }}
  </button>
  <button *ngIf="selectedPackagingPartTab === packagingPartEnum.Unit && isExcelDownloadAllowed()" mat-menu-item (click)="downloadPackagingPartExcel()" type="button">
    {{ 'dataManagement.directory.toolbar.downloadTypes.excel' | transloco }}
  </button>
  <a
    *ngIf="selectedPackagingPartTab === packagingPartEnum.Unit && !isExcelDownloadAllowed()"
    mat-menu-item
    href="{{ 'shop.webshopLink' | transloco }}"
    target="_blank"
    [matTooltip]="'dataManagement.directory.toolbar.warnings.noExcelPermissions' | transloco">
    {{ 'dataManagement.directory.toolbar.downloadTypes.excel' | transloco }}
    <mat-icon>shopping_cart</mat-icon>
  </a>
</mat-menu>
